import { render } from "./BaseTextarea.vue?vue&type=template&id=3a0336a9&scoped=true&ts=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts"

import "./BaseTextarea.vue?vue&type=style&index=0&id=3a0336a9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0336a9"]])

export default __exports__